import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Forbidden() {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="Forbidden"
      subTitle="You do not have permission to view this page."
      extra={
        <Button type="primary" onClick={() => navigate('/sites')}>
          Go to Sites
        </Button>
      }
    />
  );
}
